import { observer } from 'mobx-react-lite';
import React from 'react';

import type { IStripe, TSource } from '@feathr/blackbox';
import type { Billable } from '@feathr/blackbox';
import { Button, Card, Form } from '@feathr/components';
import BillingSource from '@feathr/extender/components/BillingSource';
import { useToggle } from '@feathr/hooks';

import PaymentMethodForm from '../PaymentMethodForm';

import * as styles from './BillableStepThree.css';

interface IProps {
  billable: Billable;
  onPrevious: () => void;
  onNext: () => void;
}

function BillableStepThree({ billable, onNext, onPrevious }: IProps) {
  const [adding, toggleAdding] = useToggle(false);

  const { source } = billable.get('stripe', {} as IStripe);

  function setSource(newSource: TSource) {
    const stripe = billable.get('stripe');
    billable.set({ stripe: { ...stripe, source: newSource, token: newSource.id } });
  }

  function unsetSource() {
    const stripe = billable.get('stripe');
    billable.set({ stripe: { ...stripe, source: undefined, token: null } });
  }

  return (
    <Form
      actions={[
        <Button key={'next'} onClick={onNext} type={'primary'}>
          Next
        </Button>,
        <Button key={'previous'} onClick={onPrevious} type={'naked'}>
          Previous
        </Button>,
      ]}
      label={'Billing configuration settings: Billing address'}
    >
      {!adding ? (
        <Card>
          {source ? (
            <BillingSource
              billable={billable}
              key={source.id}
              onDelete={unsetSource}
              onUpdate={toggleAdding}
              source={source}
            />
          ) : (
            <>
              <p className={styles.empty}>Payment method has not been set.</p>
              <Button onClick={toggleAdding}>Add payment method</Button>
            </>
          )}
        </Card>
      ) : (
        <Card title={'Set payment method'}>
          <PaymentMethodForm
            onClose={toggleAdding}
            onSave={async (updatedSource) => {
              setSource(updatedSource);
              toggleAdding();
            }}
          />
        </Card>
      )}
    </Form>
  );
}

export default observer(BillableStepThree);
